// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1572":"b24123cb","7641":"a467f737"}[chunkId] + ".chunk.css";
};